import { inject } from "@angular/core";
import { HttpInterceptorFn } from "@angular/common/http";

import { Languages } from "@azm/core/enums/languages";
import { getEnvironmentApiBaseUrl } from "@azm/core/enums/environment";
import { AuthService } from "@azm/core/services/auth";
import { ConfigService } from "@azm/core/services/config";

import { environment } from "@azm/environments/environment";

type i18n_Configurations = Record<string, keyof typeof Languages>;

const deviceTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

export const tokenInterceptor: HttpInterceptorFn = (req, next) => {
	const authService = inject(AuthService);
	const configService = inject(ConfigService);

	const url = req.url.includes("http") ? req.url : `${getEnvironmentApiBaseUrl(environment)}api/${req.url}`;

	if (req.headers.get("is-config")) return next(req);
	if (req.url.includes("http")) return next(req);

	const acceptLanguage = {
		[Languages.EN]: "en",
		[Languages.AR]: "ar",
	};

	const getCurrentLanguage = (language: Languages) => {
		return acceptLanguage[language];
	};

	const localLanguage = localStorage.getItem("azm-language") as Languages;
	const defaultLanguage = (configService.appConfig()["i18n_Configurations"] as i18n_Configurations)["defaultLanguage"] as Languages;

	const baseHeaders: Record<string, string> = {
		"X-Language": getCurrentLanguage(localLanguage ?? defaultLanguage),
		"Accept-Language": getCurrentLanguage(localLanguage ?? defaultLanguage),
		"X-TimeZone": deviceTimeZone,
		"Cache-Control": "no-store, must-revalidate",
		Pragma: "no-cache",
		Expires: "0",
	};

	const bearer = authService.token?.trim();
	if (bearer) {
		baseHeaders["Authorization"] = `Bearer ${bearer}`;
	}

	req = req.clone({
		url,
		setHeaders: baseHeaders,
	});

	return next(req);
};
